module.exports = __webpack_public_path__ + "static/img/user_icon.5b09f2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_icon.png
// module id = eYOs
// module chunks = 1